import React from 'react';

import { LoadingIconWrapper } from './styles';

export function LoadingIcon() {
  return (
    <LoadingIconWrapper>
      <div></div>
      <div></div>
      <div></div>
    </LoadingIconWrapper>
  );
}
